import _toConsumableArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GameResponseKeys } from '../../../../api/Constants';
import useFeatureFlags from '../../../../hooks/useFeatureFlags';
import { FE_DYNAMIC_GAME_ROOMS } from '../../../../utils/featureFlags/constants';
import { getText, TEXT_KEY } from '../../../../utils/localization';
import { getObjectValues } from '../../../../utils/object';
import transformObjectArrayResponse from '../../../../utils/transformObjectArrayResponse';
import transformObjectResponseKeys from '../../../../utils/transformObjectResponseKeys';
import { setActiveGameRoom, setGameRooms } from '../../../slices/gameRooms/gameRooms';
import { ONBOARDING_FLOWS } from '../../../../utils/onboarding';
import { GAME_ROOMS } from '../../../../screens/Home/constants';
import logger from '../../../../lib/analytics/logger';
import { EVENT_TYPES } from '../../../../lib/analytics/constants';
import ERROR_CODE from '../../../../utils/errorCodes';
import { setUnlimitedVipAccess, setVipRoomUnlocked, showVipAccessModal } from '../../../slices/consumables/consumables';
export var checkDynamicGameRooms = function checkDynamicGameRooms() {
  var _useFeatureFlags = useFeatureFlags(),
    hasFeature = _useFeatureFlags.hasFeature;
  return hasFeature(FE_DYNAMIC_GAME_ROOMS);
};
export var handleDynamicGameRooms = function handleDynamicGameRooms(gameRoomsResponse, dispatch, getState) {
  try {
    var _window$location, _ref3;
    var processedRooms = getObjectValues(gameRoomsResponse).flatMap(function (rooms) {
      return getObjectValues(rooms).map(function (room) {
        var _room$urlPath;
        return _objectSpread(_objectSpread({}, room), {}, {
          games: transformObjectArrayResponse(room.games).map(function (game) {
            return transformObjectResponseKeys(game, GameResponseKeys);
          }),
          news: transformObjectArrayResponse(room.news),
          roomName: room.roomName.toUpperCase(),
          urlPath: (_room$urlPath = room.urlPath) !== null && _room$urlPath !== void 0 ? _room$urlPath : room.roomName
        });
      });
    });
    var _getState = getState(),
      levelInfo = _getState.levelInfo,
      ftue = _getState.ftue,
      activeGameRoom = _getState.activeGameRoom;
    var favouritesRoom = {
      order: -1,
      room_id: -1,
      roomName: getText(TEXT_KEY.SIDE_BAR_FAVORITE),
      games: processedRooms.flatMap(function (_ref) {
        var games = _ref.games;
        return games.filter(function (game) {
          return game.IS_FAVOURITE;
        });
      }),
      urlPath: GAME_ROOMS.FAVOURITES,
      disabled: parseInt(levelInfo.level) < parseInt(ftue.onboardingsUnlockLevels[ONBOARDING_FLOWS.FAVOURITES])
    };
    var gameRooms = [].concat(_toConsumableArray(processedRooms), [favouritesRoom]);
    var useOrder = gameRooms.every(function (room) {
      return 'order' in room;
    });
    gameRooms.sort(function (a, b) {
      return useOrder ? a.order - b.order : a.room_id - b.room_id;
    });
    dispatch(setGameRooms(gameRooms));
    var pathname = (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname;
    var activeGameRoomFromUrl = gameRooms.find(function (_ref2) {
      var urlPath = _ref2.urlPath;
      return pathname ? "/home/".concat(urlPath) === pathname : urlPath === GAME_ROOMS.SLOTS;
    });
    var defaultActiveGameRoom = gameRooms.find(function (room) {
      return room.urlPath === GAME_ROOMS.SLOTS;
    });
    dispatch(setActiveGameRoom((_ref3 = activeGameRoom !== null && activeGameRoom !== void 0 ? activeGameRoom : activeGameRoomFromUrl) !== null && _ref3 !== void 0 ? _ref3 : defaultActiveGameRoom));
    var vipRoom = gameRooms.find(function (_ref4) {
      var urlPath = _ref4.urlPath;
      return urlPath === GAME_ROOMS.VIP;
    });
    if (vipRoom) {
      dispatch(showVipAccessModal(true));
      dispatch(setVipRoomUnlocked(vipRoom.can_enter_room));
      dispatch(setUnlimitedVipAccess(vipRoom.unlimited_access || false));
    }
  } catch (error) {
    logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
      error: JSON.stringify(error, Object.getOwnPropertyNames(error)),
      code: ERROR_CODE.LOBBY_OVERLAY_FETCH_GAME_ROOMS_FAIL
    });
  }
};